import { useEffect, useRef, useState } from "react";
import { glassStyle } from "../data/utils";

export function AttributionButton() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  return (
    <div
      ref={ref}
      style={{ position: "fixed", bottom: 8, right: 8, zIndex: 20 }}
    >
      {open && (
        <div
          style={{
            ...glassStyle,
            position: "absolute",
            bottom: 30,
            right: 0,
            padding: "10px 12px",
            borderRadius: 10,
            fontSize: 11,
            width: 200,
            lineHeight: 1.5,
          }}
        >
          ©{" "}
          <a
            href="https://www.mapbox.com/about/maps/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#818cf8" }}
          >
            Mapbox
          </a>{" "}
          ©{" "}
          <a
            href="https://www.openstreetmap.org/copyright"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#818cf8" }}
          >
            OpenStreetMap
          </a>{" "}
          <a
            href="https://www.mapbox.com/map-feedback/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#818cf8" }}
          >
            Improve this map
          </a>
        </div>
      )}
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Attribution"
        style={{
          ...glassStyle,
          width: 22,
          height: 22,
          padding: 0,
          borderRadius: 999,
          fontSize: 12,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        ⓘ
      </button>
    </div>
  );
}
